import { render, staticRenderFns } from "./AgentHome.vue?vue&type=template&id=5b821e24&"
import script from "./AgentHome.vue?vue&type=script&lang=js&"
export * from "./AgentHome.vue?vue&type=script&lang=js&"
import style0 from "./AgentHome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports